import React from 'react';
import moment from 'moment';

interface Props {
  value: any;
}

export default function DataPipe(props: any) {
  if (!props.value) {
    return <></>;
  }
  const data = new Date(props.value);
  const dataStr = moment(data).format('DD/MM/YYYY');
  return (
    <>
      {dataStr}
    </>
  );
} 

export const formatDate = (field: any) => (rowData: any) => {
  const date = new Date(rowData[field]);
  if (isNaN(date.getTime())) {
    return "Data inválida";
  }

  const dia = String(date.getDate()).padStart(2, "0");
  const mes = String(date.getMonth() + 1).padStart(2, "0");
  const ano = date.getFullYear();

  return `${dia}/${mes}/${ano}`;
};